import { render, staticRenderFns } from "./TabPane.vue?vue&type=template&id=463922c4&"
import script from "./TabPane.vue?vue&type=script&lang=ts&"
export * from "./TabPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports